/* eslint-disable */

import React from "react"

import { checkHasOnlyRegionsWithin, hasAnyPermission } from "shared/imports/permissionFunctions"
import {
    internationalRegions,
    stateAndLocalRegions,
    euRegions,
    usRegions,
    isInternational,
    usEURegion,
} from "shared/imports/regionConstants"

import VisualizationConsole from "search-new/containers/Visualization/VisualizationConsole/index"

import {
    WordCloudScene,
    TrendsScene,
    // create funcs
    USMapScene,
    USMapNoFederalScene,
} from "search-new/containers/Visualization/VisualizationScene/VisualizationScenes"

import {
    AmendmentTrendsScene,
    AmendmentInIssuesBarPieScene,
} from "search-new/containers/Visualization/VisualizationScene/AmendmentVisualizationScenes"

import {
    ArticleEUMapScene,
    ArticleMapScene,
    ArticleOutletBarPieScene,
    ArticlePressBarPieScene,
    ArticleStateBarPieScene,
    ArticleSourceTypeBarPieScene,
    ArticleTrendsScene,
    ArticleInIssuesBarPieScene,
} from "search-new/containers/Visualization/VisualizationScene/ArticleVisualizationScenes"

import {
    BillMapScene,
    BillGlobalMapScene,
    BillOfficialBarPieScene,
    BillCommitteeBarPieScene,
    BillCoSponsorBarPieScene,
    BillPartyBarPieScene,
    BillStateBarPieScene,
    BillTypeBarPieScene,
    BillStatusBarPieScene,
    BillGlobalStatusBarPieScene,
    BillStanceBarPieScene,
    BillPriorityBarPieScene,
    BillInIssuesBarPieScene,
    BillTrendsScene,
} from "search-new/containers/Visualization/VisualizationScene/BillVisualizationScenes"

import {
    ReceiptsBarPieScene,
    ReceiptsCommitteesBarPieScene,
    ReceiptsContactsBarPieScene,
    ReceiptsTrendsScene,
    ReceiptsPartyBarPieScene,
    ReceiptsMapScene,
} from "search-new/containers/Visualization/VisualizationScene/ReceiptsVisualizationScenes"

import { CommitteeInIssuesBarPieScene } from "search-new/containers/Visualization/VisualizationScene/CommitteeVisualizationScenes"

import {
    DocumentEUMapScene,
    DocumentOfficialBarPieScene,
    DocumentPartyBarPieScene,
    DocumentStateBarPieScene,
    DocumentCountyBarPieScene,
    DocumentMunicipalityBarPieScene,
    DocumentTypeBarPieScene,
    DocumentContactBarPieScene,
    DocumentOrganizationBarPieScene,
    DocumentPartyInternationalBarPieScene,
    DocumentCommitteeBarPieScene,
    DocumentCaucusBarPieScene,
    DocumentHashtagBarPieScene,
    DocumentRetweetBarPieScene,
    DocumentMentionBarPieScene,
    DocumentTrendsScene,
    DocumentInIssuesBarPieScene,
} from "search-new/containers/Visualization/VisualizationScene/DocumentVisualizationScenes"

import {
    EventInIssuesBarPieScene,
    EventTrendsScene,
} from "search-new/containers/Visualization/VisualizationScene/EventVisualizationScenes"

import {
    GrassrootsActionTypeBarPieScene,
    GrassrootsActionSupporterBarPieScene,
    GrassrootsActionSourceBarPieScene,
} from "search-new/containers/Visualization/VisualizationScene/GrassrootsActionVisualizationScenes"

import {
    NoteUSMapScene,
    NoteEUMapScene,
    NoteTeamBarPieScene,
    NoteCreatorBarPieScene,
    NoteOfficeBarPieScene,
    NotePartyBarPieScene,
    NoteTypeBarPieScene,
    NoteDonationTypeBarPieScene,
    NoteStateBarPieScene,
    NoteMemberBarPieScene,
    NotePressContactBarPieScene,
    NoteSupporterBarPieScene,
    NotePublicOrganizationBarPieScene,
    NoteOrganizationBarPieScene,
    NoteProjectBarPieScene,
    NotePartyInternationalBarPieScene,
    NoteTrendsScene,
} from "search-new/containers/Visualization/VisualizationScene/NoteVisualizationScenes"

import {
    PersonMapScene,
    PersonEUMapScene,
    OfficialInIssuesBarPieScene,
    OfficialPartyBarPieScene,
} from "search-new/containers/Visualization/VisualizationScene/OfficialVisualizationScenes"

import {
    PublicOrganizationInIssuesBarPieScene,
    PublicOrganizationInternationalBarPieScene,
} from "search-new/containers/Visualization/VisualizationScene/PublicOrganizationVisualizationScenes"

import {
    RegulationAgencyBarPieScene,
    RegulationTrendsScene,
    RegulationTypeBarPieScene,
    RegulationStateBarPieScene,
    RegulationStatusBarPieScene,
    RegulationGlobalStatusBarPieScene,
    RegulationStanceBarPieScene,
    RegulationPriorityBarPieScene,
    RegulationInIssuesBarPieScene,
    RegulationGlobalMapScene,
} from "search-new/containers/Visualization/VisualizationScene/RegulationVisualizationScenes"

import { StafferInIssuesBarPieScene } from "search-new/containers/Visualization/VisualizationScene/StafferVisualizationScenes"

import {
    SupporterSourceBarPieScene,
    SupporterCreatedTrendsScene,
    SupporterInIssuesBarPieScene,
} from "search-new/containers/Visualization/VisualizationScene/SupporterVisualizationScenes"

import {
    VoteTrendsScene,
    VoteInIssuesBarPieScene,
} from "search-new/containers/Visualization/VisualizationScene/VoteVisualizationScenes"

import {
    PressContactInIssuesBarPieScene,
    PressContactOutletBarPieScene,
    PressContactTypeBarPieScene,
} from "search-new/containers/Visualization/VisualizationScene/PressContactVisualizationScenes"

const genericVisualizationConsole = (props) => <VisualizationConsole {...props} />

export const AmendmentVisualizationConsole = (props) =>
    genericVisualizationConsole({
        ...props,
        buttonGroups: [
            {
                label: "When",
                icon: "fa-calendar",
                dropdownScenes: [AmendmentTrendsScene],
            },
            {
                label: "What",
                icon: "fa-hashtag",
                dropdownScenes: [AmendmentInIssuesBarPieScene],
            },
        ],
        defaultActiveSceneId: AmendmentTrendsScene.defaultProps.uniqueVizSceneId,
    })

export const ArticleVisualizationConsole = (props) =>
    genericVisualizationConsole({
        ...props,
        buttonGroups: [
            {
                label: "Who",
                icon: "fa-users",
                dropdownScenes: [ArticleOutletBarPieScene, ArticlePressBarPieScene],
            },
            {
                label: "Where",
                icon: "fa-map",
                dropdownScenes: [
                    checkHasOnlyRegionsWithin(usRegions) && ArticleMapScene,
                    checkHasOnlyRegionsWithin(euRegions) && ArticleEUMapScene,
                    ArticleStateBarPieScene,
                ],
            },
            {
                label: "When",
                icon: "fa-calendar",
                dropdownScenes: [ArticleTrendsScene],
            },
            {
                label: "What",
                icon: "fa-hashtag",
                dropdownScenes: [WordCloudScene, ArticleSourceTypeBarPieScene, ArticleInIssuesBarPieScene],
            },
        ],
        defaultActiveSceneId: "ArticleTrendsScene",
    })

export const BillVisualizationConsole = (props) =>
    genericVisualizationConsole({
        ...props,
        buttonGroups: [
            {
                label: "Who",
                icon: "fa-users",
                dropdownScenes: [
                    BillOfficialBarPieScene,
                    BillCoSponsorBarPieScene,
                    BillPartyBarPieScene,
                    !isInternational && BillCommitteeBarPieScene,
                ],
            },
            {
                label: "Where",
                icon: "fa-map",
                dropdownScenes: [
                    Userdata.isGlobalMode() && BillGlobalMapScene,
                    checkHasOnlyRegionsWithin(usRegions) && BillMapScene,
                    BillStateBarPieScene,
                ],
            },
            {
                label: "When",
                icon: "fa-calendar",
                dropdownScenes: [BillTrendsScene],
            },
            {
                label: "What",
                icon: "fa-hashtag",
                dropdownScenes: [
                    BillTypeBarPieScene,
                    ...(Userdata.isGlobalMode() ? [BillGlobalStatusBarPieScene] : [BillStatusBarPieScene]),
                    ...(hasAnyPermission([DjangIO.app.models.PermissionType.hide_stance])
                        ? []
                        : [BillStanceBarPieScene]),
                    ...(hasAnyPermission([DjangIO.app.models.PermissionType.hide_priority])
                        ? []
                        : [BillPriorityBarPieScene]),
                    BillInIssuesBarPieScene,
                ],
            },
        ],
        defaultActiveSceneId: USMapScene.defaultProps.uniqueVizSceneId,
    })

export const ReceiptsVisualizationConsole = (props) => {
    return genericVisualizationConsole({
        ...props,
        resource: DjangIO.app.moneyball.models.Visualization,
        buttonGroups: [
            {
                label: "Who",
                icon: "fa-users",
                dropdownScenes: [
                    !isInternational && ReceiptsBarPieScene,
                    ReceiptsCommitteesBarPieScene,
                    ReceiptsPartyBarPieScene,
                    ReceiptsContactsBarPieScene,
                ],
            },
            {
                label: "Where",
                icon: "fa-map",
                dropdownScenes: [checkHasOnlyRegionsWithin(usRegions) && ReceiptsMapScene],
            },
            {
                label: "When",
                icon: "fa-calendar",
                dropdownScenes: [ReceiptsTrendsScene],
            },
        ],
        defaultActiveSceneId: USMapScene.defaultProps.uniqueVizSceneId,
    })
}

export const CommitteeVisualizationConsole = (props) =>
    genericVisualizationConsole({
        ...props,
        buttonGroups: [
            {
                label: "Where",
                icon: "fa-map",
                dropdownScenes: [USMapNoFederalScene],
            },
            {
                label: "What",
                icon: "fa-hashtag",
                dropdownScenes: [CommitteeInIssuesBarPieScene],
            },
        ],
        defaultActiveSceneId: undefined,
    })

export const DocumentVisualizationConsole = (props) =>
    genericVisualizationConsole({
        ...props,
        buttonGroups: [
            {
                label: "Who",
                icon: "fa-users",
                dropdownScenes: [
                    DocumentOfficialBarPieScene,
                    checkHasOnlyRegionsWithin(usEURegion) && DocumentPartyBarPieScene,
                    checkHasOnlyRegionsWithin(internationalRegions) && DocumentPartyInternationalBarPieScene,
                    !isInternational && DocumentCommitteeBarPieScene,
                    checkHasOnlyRegionsWithin(usRegions) && DocumentCaucusBarPieScene,
                    DocumentContactBarPieScene,
                    DocumentOrganizationBarPieScene,
                    DocumentRetweetBarPieScene,
                    DocumentMentionBarPieScene,
                ],
            },
            {
                label: "Where",
                icon: "fa-map",
                dropdownScenes: [
                    checkHasOnlyRegionsWithin(usRegions) && USMapScene,
                    checkHasOnlyRegionsWithin(euRegions) && DocumentEUMapScene,
                    DocumentStateBarPieScene,
                    DocumentCountyBarPieScene,
                    DocumentMunicipalityBarPieScene,
                ],
            },
            {
                label: "When",
                icon: "fa-calendar",
                dropdownScenes: [DocumentTrendsScene],
            },
            {
                label: "What",
                icon: "fa-hashtag",
                dropdownScenes: [
                    WordCloudScene,
                    DocumentTypeBarPieScene,
                    DocumentHashtagBarPieScene,
                    DocumentInIssuesBarPieScene,
                ],
            },
        ],
        defaultActiveSceneId: undefined,
    })

export const EventVisualizationConsole = (props) =>
    genericVisualizationConsole({
        ...props,
        buttonGroups: [
            {
                label: "Where",
                icon: "fa-map",
                dropdownScenes: [USMapNoFederalScene],
            },
            {
                label: "What",
                icon: "fa-hashtag",
                dropdownScenes: [EventInIssuesBarPieScene],
            },
            {
                label: "When",
                icon: "fa-calendar",
                dropdownScenes: [EventTrendsScene],
            },
        ],
        defaultActiveSceneId: undefined,
    })

export const GrassrootsActionVisualizationConsole = (props) =>
    genericVisualizationConsole({
        ...props,
        buttonGroups: [
            {
                label: "Who",
                icon: "fa-users",
                dropdownScenes: [NoteMemberBarPieScene, GrassrootsActionSupporterBarPieScene, NotePartyBarPieScene],
            },
            {
                label: "Where",
                icon: "fa-map",
                dropdownScenes: [
                    checkHasOnlyRegionsWithin(usRegions) && USMapScene,
                    checkHasOnlyRegionsWithin(euRegions) && NoteEUMapScene,
                    NoteStateBarPieScene,
                ],
            },
            {
                label: "When",
                icon: "fa-calendar",
                dropdownScenes: [TrendsScene],
            },
            {
                label: "What",
                icon: "fa-hashtag",
                dropdownScenes: [WordCloudScene, GrassrootsActionTypeBarPieScene, GrassrootsActionSourceBarPieScene],
            },
        ],
        defaultActiveSceneId: undefined,
    })

export const NoteVisualizationConsole = (props) =>
    genericVisualizationConsole({
        ...props,
        buttonGroups: [
            {
                label: "Who",
                icon: "fa-users",
                dropdownScenes: [
                    NoteTeamBarPieScene,
                    NoteCreatorBarPieScene,
                    checkHasOnlyRegionsWithin(usEURegion) && NoteOfficeBarPieScene,
                    checkHasOnlyRegionsWithin(usEURegion) && NotePartyBarPieScene,
                    checkHasOnlyRegionsWithin(internationalRegions) && NotePartyInternationalBarPieScene,
                    NoteMemberBarPieScene,
                    NotePressContactBarPieScene,
                    NoteSupporterBarPieScene,
                    NotePublicOrganizationBarPieScene,
                    NoteOrganizationBarPieScene,
                ],
            },
            {
                label: "Where",
                icon: "fa-map",
                dropdownScenes: [
                    checkHasOnlyRegionsWithin(usRegions) && NoteUSMapScene,
                    checkHasOnlyRegionsWithin(euRegions) && NoteEUMapScene,
                    NoteStateBarPieScene,
                ],
            },
            {
                label: "When",
                icon: "fa-calendar",
                dropdownScenes: [NoteTrendsScene],
            },
            {
                label: "What",
                icon: "fa-hashtag",
                dropdownScenes: [NoteTypeBarPieScene, NoteDonationTypeBarPieScene, NoteProjectBarPieScene],
            },
        ],
        defaultActiveSceneId: undefined,
    })

export const OfficialVisualizationConsole = (props) =>
    genericVisualizationConsole({
        ...props,
        buttonGroups: [
            {
                label: "Who",
                icon: "fa-users",
                dropdownScenes: [OfficialPartyBarPieScene],
            },
            {
                label: "Where",
                icon: "fa-map",
                dropdownScenes: [
                    checkHasOnlyRegionsWithin(usRegions) && PersonMapScene,
                    checkHasOnlyRegionsWithin(euRegions) && PersonEUMapScene,
                ],
            },
            {
                label: "What",
                icon: "fa-hashtag",
                dropdownScenes: [OfficialInIssuesBarPieScene],
            },
        ],
        defaultActiveSceneId: undefined,
    })

export const PublicOrganizationVisualizationConsole = (props) =>
    genericVisualizationConsole({
        ...props,
        buttonGroups: [
            {
                label: "Where",
                icon: "fa-map",
                dropdownScenes: [
                    checkHasOnlyRegionsWithin(stateAndLocalRegions) && USMapNoFederalScene,
                    checkHasOnlyRegionsWithin(euRegions) && PersonEUMapScene,
                ],
            },
            {
                label: "What",
                icon: "fa-hashtag",
                dropdownScenes: [PublicOrganizationInIssuesBarPieScene, PublicOrganizationInternationalBarPieScene],
            },
        ],
        defaultActiveSceneId: undefined,
    })

export const StafferVisualizationConsole = checkHasOnlyRegionsWithin(usRegions)
    ? (props) =>
          genericVisualizationConsole({
              ...props,
              buttonGroups: [
                  {
                      label: "Where",
                      icon: "fa-map",
                      dropdownScenes: [PersonMapScene],
                  },
                  {
                      label: "What",
                      icon: "fa-hashtag",
                      dropdownScenes: [StafferInIssuesBarPieScene],
                  },
              ],
              defaultActiveSceneId: undefined,
          })
    : undefined

export const RegulationVisualizationConsole = (props) =>
    genericVisualizationConsole({
        ...props,
        buttonGroups: [
            {
                label: "Who",
                icon: "fa-users",
                dropdownScenes: [RegulationAgencyBarPieScene],
            },
            {
                label: "Where",
                icon: "fa-map",
                dropdownScenes: [
                    Userdata.isGlobalMode() && RegulationGlobalMapScene,
                    checkHasOnlyRegionsWithin(usRegions) && USMapScene,
                    RegulationStateBarPieScene,
                ],
            },
            {
                label: "When",
                icon: "fa-calendar",
                dropdownScenes: [RegulationTrendsScene],
            },
            {
                label: "What",
                icon: "fa-hashtag",
                dropdownScenes: [
                    RegulationTypeBarPieScene,
                    ...(Userdata.isGlobalMode() ? [RegulationGlobalStatusBarPieScene] : [RegulationStatusBarPieScene]),
                    RegulationStanceBarPieScene,
                    RegulationPriorityBarPieScene,
                    RegulationInIssuesBarPieScene,
                ],
            },
        ],
        defaultActiveSceneId: undefined,
    })

export const SupporterVisualizationConsole = (props) =>
    genericVisualizationConsole({
        ...props,
        buttonGroups: [
            {
                label: "Where",
                icon: "fa-map",
                dropdownScenes: [
                    checkHasOnlyRegionsWithin(usRegions) && PersonMapScene,
                    checkHasOnlyRegionsWithin(euRegions) && PersonEUMapScene,
                ],
            },
            {
                label: "When",
                icon: "fa-calendar",
                dropdownScenes: [SupporterCreatedTrendsScene],
            },
            {
                label: "What",
                icon: "fa-hashtag",
                dropdownScenes: [SupporterSourceBarPieScene, SupporterInIssuesBarPieScene],
            },
        ],
        defaultActiveSceneId: undefined,
    })

export const VoteVisualizationConsole = (props) =>
    genericVisualizationConsole({
        ...props,
        buttonGroups: [
            {
                label: "Where",
                icon: "fa-map",
                dropdownScenes: [checkHasOnlyRegionsWithin(stateAndLocalRegions) && USMapNoFederalScene],
            },
            {
                label: "When",
                icon: "fa-calendar",
                dropdownScenes: [VoteTrendsScene],
            },
            {
                label: "What",
                icon: "fa-hashtag",
                dropdownScenes: [VoteInIssuesBarPieScene],
            },
        ],
        defaultActiveSceneId: undefined,
    })

export const VoteResultVisualizationConsole = (props) =>
    genericVisualizationConsole({
        ...props,
        buttonGroups: [
            {
                label: "When",
                icon: "fa-calendar",
                dropdownScenes: [VoteTrendsScene],
            },
        ],
        defaultActiveSceneId: undefined,
    })

export const PressContactVisualizationConsole = (props) =>
    genericVisualizationConsole({
        ...props,
        buttonGroups: [
            {
                label: "What",
                icon: "fa-hashtag",
                dropdownScenes: [
                    PressContactOutletBarPieScene,
                    PressContactInIssuesBarPieScene,
                    PressContactTypeBarPieScene,
                ],
            },
            {
                label: "Where",
                icon: "fa-map",
                dropdownScenes: [checkHasOnlyRegionsWithin(usRegions) && USMapScene],
            },
        ],
        defaultActiveSceneId: undefined,
    })

/* eslint-enable */
